import { NetType, Cuts, CutTypes } from "./types";
import { isNil } from "ramda";

export function resolveImage(
	cut: Cuts,
	bottomNetCount: number,
	topNetCount: number,
	leftCut: string,
	rightCut: string,
	netType: NetType,
) {
	if (
		isNil(cut) ||
		isNil(bottomNetCount) ||
		isNil(topNetCount) ||
		isNil(leftCut) ||
		isNil(rightCut)
	) {
		return null;
	}

	if (netType === NetType.SQUARE) {
		if (bottomNetCount === topNetCount) {
			return "square-eq";
		} else {
			return "square-neq";
		}
	} else {	
		if (cut === Cuts.SYMMETRICAL) {
			if (bottomNetCount === topNetCount) {
				return "symm-eq";
			} else {
				return "symm-neq";
			}
		} else {
			if (leftCut === "N") {
				return "nsymm-lcn";
			}
			if (rightCut === "N") {
				return "nsymm-rcn";
			}
			return "nsymm-other";
		}
	}
}
